module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      header_timer: _vm.isActive
    },
    attrs: {
      "id": "header_timer"
    }
  }, [(!_vm.time.isOld) ? _c('div', [_c('h3', {
    staticClass: "insert-text"
  }, [_vm._v("距离本届糖酒会开幕")]), _vm._v(" "), _c('p', {
    staticClass: "insert-text"
  }, [_vm._v("还有"), _c('span', [_vm._v(_vm._s(_vm.time.day))]), _vm._v("天")])]) : _c('div', [_c('h3', {
    staticClass: "insert-text"
  }, [_vm._v("新一轮的招商已启动")]), _vm._v(" "), _c('p', {
    staticClass: "insert-text"
  }, [_vm._v("今天已经"), _c('span', [_vm._v(_vm._s(_vm.time.day))]), _vm._v("号啦")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0be7226e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Timer.vue
// module id = 164
// module chunks = 1